import React from 'react';
import { useConsent } from '../../contexts/ConsentContext';
import './footer.css';

const Footer = () => {
  const { openSettings } = useConsent();

  return (
    <footer className="footer-component">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-company">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><a href="/assets">Assets</a></li>
              <li><a href="/tokenization">Tokenization</a></li>
              <li><a href="/team">Team</a></li>
              <li><a href="/news">News</a></li>
            </ul>
          </div>
          
          <div className="footer-section footer-brand">
            <h3 className="footer-logo">Real World Equity</h3>
            <p className="footer-description">
              Transforming real estate investment through innovative tokenization technology.
              Making premium assets accessible to everyone.
            </p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/real-world-equity/posts/?feedView=all" className="social-link">LinkedIn</a>
              <a href="#" className="social-link">Twitter</a>
              <a href="#" className="social-link">Facebook</a>
              <a href="#" className="social-link">Instagram</a>
            </div>
          </div>
          
          <div className="footer-section footer-contact">
            <h4>Contact</h4>
            <div className="contact-info">
              <p>16818 Dallas Parkway, # 100<br />Dallas, TX 75248</p>
              <p>📧 info@realworldequity.com</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Real World Equity. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="/legal">Legal</a>
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/privacy-requests">Privacy Requests</a>
              <a href="/legal">Terms of Service</a>
              <button onClick={openSettings} className="footer-cookie-settings">Cookie Settings</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
